<template>
  <div class="notice-wrap bookingPolicy" id="guestInfoPolicy">
    <div
      class="notice js-noticeSlide"
      :class="{ active: isBookingPolicyShow }"
      @click="isBookingPolicyShow = !isBookingPolicyShow"
    >
      <div class="notice-line"></div>
      <div class="notice-txt">预订政策</div>
      <div class="notice-arrow">
        <img
          src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon15.png"
        />
      </div>
    </div>

    <div class="notice-detail js-smartScroll" v-show="isBookingPolicyShow">
      <PolicyContent
        :customClass="'guestInfo'"
        :visaContent="visaContent"
        :departureCode="departureCode"
        :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
        :isSevenDayNrpCruise="isSevenDayNrpCruise"
        :showBankPopup="showBankPopup"
        :currentTab="currentTab"
        :outsideTop="outsideTop"
        :hasNrp="hasNrp"
        :hasRp="hasRp"
        :isShowSpecialBooking="isShowSpecialBooking"
        :shipCode="shipCode"
        :sailDate="sailDate"
        :isDownPayCruise="isDownPayCruise"
        :showRow="showRow"
      />
    </div>
  </div>
</template>

<script>

const PolicyContent = () => import("@/components/Cruise/PolicyContent");
export default {
  name: "GuestInfoPolicy",
  components: {
    PolicyContent,
  },
  props: {
    showBankPopup: {
      type: Function,
    },
    isDownPayCruise: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBookingPolicyShow: true,
      currentTab: 0,
      outsideTop: 0,
    };
  },
  mounted() {
    setTimeout(()=> {
      this.currentTab = 5;
      this.outsideTop = document.getElementById("guestInfoPolicy").offsetTop;
    }, 500)
  },
  methods:{
  },
  computed: {
    order() {
      return this.$store.state.booking.order;
    },
    bookings() {
      if (!this.order.bookings || this.order.bookings.length == 0) {
        return [];
      }
      return this.order.bookings;
    },
		shipCode () {
			if (this.bookings.length == 0) {
				return "";
			}
			return this.bookings[0].shipCode;
		},
    sailDate () {
      if (this.bookings.length == 0) {
				return "";
			}
			return this.bookings[0].sailDate;
    },
    visaContent() {
      return this.order ? this.order.visaWarning : {};
    },
    departureCode() {
      return this.order ? this.order.departureCode : "";
    },
    isSevenDayNrpCruise() {
      return this.ordrer ? this.order.isSevenDayNrpCruise : false;
    },
    isFortyEightHoursNrpCruise() {
      return this.order.isFortyEightHoursNrpCruise
        ? this.order.isFortyEightHoursNrpCruise
        : false;
    },
    hasNrp() {
      if (
        this.bookings.length == 0 ||
        this.isSevenDayNrpCruise ||
        this.isFortyEightHoursNrpCruise
      ) {
        return false;
      }
      return this.bookings.some((r) => r.isnrp);
    },
    hasRp() {
      if (
        this.bookings.length == 0 ||
        this.isSevenDayNrpCruise ||
        this.isFortyEightHoursNrpCruise
      ) {
        return false;
      }
      return this.bookings.some((r) => !r.isnrp);
    },
    isShowSpecialBooking() {
      return (
        this.order &&
        this.order.specialBookingInfoView &&
        this.order.specialBookingInfoView.specialBookingViewModels &&
        this.order.specialBookingInfoView.specialBookingViewModels.length > 0
      );
    },
  },
};
</script>

<style lang="less" scoped>
.notice-wrap {
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  .notice-line {
    -webkit-box-flex: 0;
    -webkit-flex: none;
    -moz-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 3px;
    height: 14px;
    margin-right: 5px;
    background-color: #4a90e2;
    border-radius: 1px;
  }
  .notice-txt {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    color: #4a90e2;
    font-weight: 600;
  }
  .notice-arrow {
    -webkit-box-flex: 0;
    -webkit-flex: none;
    -moz-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 11px;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
  .active .notice-arrow {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
#guestInfoPage .bookingPolicy {
  padding-bottom: 0px;
}
.notice {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
  padding: 17px 32px 14px 25px;
  background-color: #fff;
  img {
    max-width: 100%;
  }
}
.notice-item {
  margin: 0 15px 17px 25px;
  padding-left: 8px;
  border-bottom: 1px solid #cccccc;
  .no-shorex {
    font-size: 12px;
    padding-bottom: 10px;
    color: #666;
  }
  .notice-item-title {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 20px;
    color: #4a90e2;
  }
  .notice-item-text {
    padding-bottom: 15px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
    .visa_right__titlt {
      font-weight: bold;
      margin-top: 16px !important;
      color: #333 !important;
    }
    p {
      margin: 0;
    }
  }
}
.notice-item:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
.notice-detail {
  height: 250px;
  overflow-y: auto;
}
</style>
